import { render, staticRenderFns } from "./CareerDetailsSM.vue?vue&type=template&id=48d95c00&scoped=true"
import script from "./CareerDetailsSM.vue?vue&type=script&lang=js"
export * from "./CareerDetailsSM.vue?vue&type=script&lang=js"
import style0 from "./CareerDetailsSM.vue?vue&type=style&index=0&id=48d95c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d95c00",
  null
  
)

export default component.exports